import { createSlice } from "@reduxjs/toolkit";
import generatePdfApi from "@custom/rtk-apis/appointment/generatePDF";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const generatePdfSlice = createSlice({
  name: "generatePdfSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    builder
      .addCase(generatePdfApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(generatePdfApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(generatePdfApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default generatePdfSlice.reducer;
export const { revertStatus } = generatePdfSlice.actions;
